import {
  Component, OnInit, Input, ViewChild, ElementRef,
  forwardRef, AfterViewInit, Renderer2, HostListener,
  TemplateRef, ContentChild, Output, EventEmitter, HostBinding, SimpleChanges, OnChanges, ChangeDetectorRef, OnDestroy, Optional, Host
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import {
  ControlValueAccessor, NG_VALUE_ACCESSOR,
  NG_VALIDATORS, UntypedFormControl, FormGroupDirective, FormControlName, Validator
} from '@angular/forms';
import { AddMoreAutosuggestDirective } from '@otas/utils/directives/helper/add-more-autosuggest.directive';
import { FilterSearchPipe } from '@otas/utils/pipes/filter-search.pipe';
import * as _ from 'underscore';
import { FocusNextDirective } from '@otas/utils/directives/helper/focus-next.directive';
import { isNumber } from '@otas/utils/custom-components/panchang-calendar/panchang-helper';
import { EnterKeyListenerDirective } from '../../directives/helper/enter.directive';
declare let $: any;
@Component({
    selector: 'app-auto-suggest',
    templateUrl: './auto-suggest.component.html',
    styleUrls: ['./auto-suggest.component.css'],
    providers: [
        FocusNextDirective,
        {
            provide: NG_VALUE_ACCESSOR,
            /* tslint:disabled */
            useExisting: forwardRef(() => AutoSuggestComponent),
            /* tslint:enable */
            multi: true
        },
    ],
    standalone: false
})
export class AutoSuggestComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit, Validator, ControlValueAccessor {

  mappedOptions: AutoSuggestOption[];
  @Input() options: AutoSuggestOption[] = [];
  @Input() optionsGroup: AutoSuggestOptionGroup[] = [];
  @Input() isGroup = false;
  @Input() type = 'text';
  @Input() reset = false;
  @Input() placeholder: string;
  @Input() inputCssClass = 'form-control';
  @Output() selected: EventEmitter<AutoSuggestOption> = new EventEmitter<AutoSuggestOption>();
  @ViewChild('spanField', { static: true }) span: ElementRef;
  @ViewChild('inputField', { static: false }) input: ElementRef;
  @ViewChild('dropDownItem', { static: false }) ddItem: ElementRef;
  @Input() @HostBinding('tabindex') tabindex = -1;
  @Input() /*@HostBinding('attr.disabled')*/ isDisable = false;
  @Input() /* @HostBinding('class')*/ clas = this.isDisable;
  @Input() isFilter = true;
  public dropDown = false;
  selectedId: string | number;
  selectedItem: AutoSuggestOption;
  inputValue: string;
  activeOption: AutoSuggestOption;
  documentClick: Subscription;
  @ContentChild(AddMoreAutosuggestDirective, { read: TemplateRef, static: false }) addMoreTemplate;

  onChange = (_f: any) => { };
  onTouched = () => { };
  constructor(public _elementRef: ElementRef, private renderer: Renderer2, private cd: ChangeDetectorRef,
    @Optional() @Host() private enterKeyDirective: EnterKeyListenerDirective,
    private focusnxt: FocusNextDirective, @Optional() @Host() private formGroupDirective: FormGroupDirective) {
    this.closeDropDown = this.closeDropDown.bind(this);

  }
  isActive(o) {
    return !!this.activeOption ? this.activeOption.id === o.id : false;
  }
  ngOnChanges(changes: SimpleChanges) {


    if (this.optionsGroup && this.optionsGroup.length) {
      this.optionsGroup.forEach(a => { a.options.forEach(o => this.options.push(o)); });

    }
    this.mappedOptions = _.map(this.options);
    if (changes.options && changes.options.currentValue) {

      this.focusInput();
      if (!!this.selectedId) {

        this.selectedItem = _.find(this.options, o => o.id === this.selectedId);
        if (this.selectedItem) {
          this.activeOption = this.selectedItem;
          this.onChange(this.selectedId = this.selectedItem.id);
        }
        this.cd.markForCheck();
      }
    }

    this.spanDisable();


  }
  clear() {
    if (!this.isDisable) {
      this.activeOption = undefined;
      this.selectedItem = this.activeOption;
      this.onChange(undefined);

    }
  }
  spanDisable() {
    if (this.isDisable) {
      this.renderer.setStyle(this.span.nativeElement, 'background-color', '#f5f5f5');
      this.renderer.setStyle(this.span.nativeElement, 'color', '#999999');
      this.renderer.setStyle(this.span.nativeElement, 'cursor', 'not-allowed');
    } else {
      this.renderer.removeStyle(this.span.nativeElement, 'background-color');
      this.renderer.removeStyle(this.span.nativeElement, 'color');
      this.renderer.removeStyle(this.span.nativeElement, 'cursor');
    }
  }
  ngOnInit() {
    // console.log("on component",this.options)
    this.focusInput();
  }
  focusOut(event) {
    this.dropDown = false;
    if (this.activeOption) {
      this.selectedItem = this.activeOption;
      this.itemSelected(this.activeOption, false, true);
    }
  }
  focusInput() {
    const focusInput = fromEvent(this.span.nativeElement, 'click').subscribe((data: any) => {
      if (!this.isDisable) {
        this.dropDown = true;
        this.inputValue = '';
        setTimeout(() => {
          if (!!this.input) {
            this.input.nativeElement.focus();
          }
        }, 100);
      }
    });
    fromEvent(this.span.nativeElement, 'focus').subscribe((data: any) => {
      if (!this.isDisable) {
        this.dropDown = true;
        this.inputValue = '';
        setTimeout(() => {
          if (!!this.input) {
            this.input.nativeElement.focus();
          }
        }, 100);
      }
    });

  }
  inputChanges(value) {
    this.inputValue = value;
    this.activeOption = null;
    const filter = new FilterSearchPipe();
    this.options = [];
    const filteredOpts = filter.transform(_.map(this.mappedOptions),
      this.inputValue, isNumber(this.inputValue) ? 'prefix' : 'name', 'startsWith');

    this.options = !!this.inputValue ?
      (filteredOpts && filteredOpts.length) ? filteredOpts : _.map(this.mappedOptions) : _.map(this.mappedOptions);

    this.options.length === 1 ? this.itemSelected(this.options[0], true, false) :
      !this.options.length ? this.itemSelected(null, false, true) : this.itemSelected(this.options[0], true, false);

    if (this.isGroup) {
      this.optionsGroup = [];

      const groupNames = _.uniq(_.map(this.options, e => e.groupName));
      const groupByTitle = _.groupBy(_.map(this.options, e => {
        return e;
      }), e => e.groupName);

      groupNames.forEach(n => {
        this.optionsGroup.push({ title: n, options: groupByTitle[n] });
      });
      this.optionsGroup = _.uniq(this.optionsGroup, o => o.title);
    }
  }
  @HostListener('keyup', ['$event'])
  keyUp(event: KeyboardEvent) {
    if (event.key === 'Arrow Left' || event.key === 'Arrow Up' || event.key === 'Arrow Right' || 
          event.key === 'Arrow Down' || event.key === 'Enter') {
      event.preventDefault();
      return;
    }
  }
  onIputKeyDown(event: KeyboardEvent) {

    if (event.key === 'Enter' && this.enterKeyDirective && !this.isDisable) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      const parent = (this.enterKeyDirective as any).el.nativeElement;
      this.focusnxt.selectClick(parent, this._elementRef);
      if (!!this.inputValue && this.options.length && !this.activeOption) {
        this.activeOption = this.options[0];
      }
      this.itemSelected(this.selectedItem = this.activeOption, false);
    }
  }
  @HostListener('focus')
  onFocus() {
    if (!this.isDisable) {
      this.span.nativeElement.focus();
    }
  }
  @HostListener('blur')
  onblur() {
    if (!this.isDisable) {
      this.onTouched();
    }
  }
  @HostListener('keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (!this.isDisable) {
      const activeIndex = this.options.indexOf(this.activeOption);
      // up
      if (event.key === 'Arrow Up' && this.options.length) {

        const count: number = activeIndex < 0 ? this.options.length - 1 : activeIndex - 1;
        this.ensureHighlightVisible(count);
        event.preventDefault();

        return;
      }
      // down
      if (event.key === 'Arrow Down' && this.options.length) {
        const count: number = activeIndex < 0 ? 0 : activeIndex + 1;
        this.ensureHighlightVisible(count);
        event.preventDefault();
        return;
      }
      // enter
      if (event.key === 'Enter' || event.key === 'Ctrl') {        
        event.preventDefault();
        if (!!this.inputValue && this.options.length && !this.activeOption) {
          this.activeOption = this.options[0];
        }
        this.itemSelected(this.selectedItem = this.activeOption, false);

        return;
      }

    }
  }
  ngAfterViewInit() {
    this.documentClick = fromEvent(document, 'click').subscribe((event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!this._elementRef.nativeElement.contains(target)) {
        this.closeDropDown();
      }
    });
  }
  
  mouseOver(item: AutoSuggestOption) {
    this.activeOption = item;
  }
  mouseleave() {
    this.activeOption = null;
  }
  public validate(c: UntypedFormControl): any {
    const controlValue = c ? c.value : null;
    const autoSuggestDir: FormControlName =
      _.find(this.formGroupDirective.directives, (e: FormControlName) => e.valueAccessor instanceof AutoSuggestComponent);
    if (autoSuggestDir) {
      return autoSuggestDir.errors && !controlValue ? autoSuggestDir.errors : null;
    }
    return null;
  }
  public ensureHighlightVisible(active = 0): void {
    const container = this._elementRef.nativeElement.querySelector('.dropdown-menu');
    this.itemSelected(this.options[active], true);

    if (!container) {
      return;
    }
    const choices = container.querySelectorAll('.drop-down-row');
    if (choices.length < 1) {
      return;
    }
    const activeIndex = active;
    if (activeIndex < 0) {
      return;
    }
    const highlighted: any = choices[activeIndex];
    if (!highlighted) {
      return;
    }
    container.scrollTop = activeIndex === 0 ? 0 : container.scrollTop;
    const posY: number = (highlighted.offsetTop + highlighted.clientHeight) - container.scrollTop;
    const height: number = container.offsetHeight;

    if (posY > height) {
      container.scrollTop += posY - height;
    } else if (posY < highlighted.clientHeight) {
      container.scrollTop -= highlighted.clientHeight - posY;
    }
    this.selectedItem = this.activeOption;
    const selectedId = this.selectedItem ? this.selectedItem.id : null;
    this.onChange(this.selectedId = selectedId);
    this.selected.emit(this.selectedItem);
  }
  itemSelected(item, dropDown = false, isClick = false) {
    this.dropDown = dropDown;
    this.activeOption = item;
    this.selectedItem = this.activeOption;
    if (!this.dropDown) {
      const selectedId = item ? item.id : null;
      this.options = _.map(this.mappedOptions); this.onChange(this.selectedId = selectedId);
      this.selected.emit(item);
      if (isClick) {
        this.selectedItem = item;
        if (this.enterKeyDirective) {
          const parent = (this.enterKeyDirective as any).el.nativeElement;
          this.focusnxt.selectClick(parent, this._elementRef);
        }
      } else {
        if (this.enterKeyDirective) {
          const parent = (this.enterKeyDirective as any).el.nativeElement;
          this.focusnxt.selectClick(parent, this._elementRef);
        }
      }
    }

  }
  closeDropDown() {
    const parent = this.renderer.parentNode(this._elementRef.nativeElement);
    if (!parent.classList.contains('has-danger')) {
      this.dropDown = false;
      this.inputValue = '';
      this.options = _.map(this.mappedOptions);
    }
  }


  writeValue(obj: any): void {
    if (!!obj) {
      this.selectedId = obj;
      this.selectedItem = _.find(this.options, o => o.id === obj);
      if (this.selectedItem) {
        this.activeOption = this.selectedItem;
        this.onChange(this.selectedId = this.selectedItem.id);
      }
      this.cd.markForCheck();
    } else {
      this.selectedItem = undefined;
      this.activeOption = undefined;
    }

  }

  registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisable = isDisabled;
    this.renderer.setAttribute(this._elementRef.nativeElement, 'ng-reflect-is-disable', isDisabled ? 'true' : 'false');
    this.spanDisable();
    this.cd.markForCheck();
  }
  ngOnDestroy(): void {
    if (this.documentClick) {
      this.documentClick.unsubscribe();
    }
  }

}
export class AutoSuggestOption {
  name: string;
  id: string | number;
  checked?: boolean;
  prefix?: any;
  suffix?: any;
  object?: any;
  groupName?: any;
} export class AutoSuggestOptionGroup {
  title: string;
  options: AutoSuggestOption[];
}
